<div class="header">
  <h2>Lernende</h2>
</div>

<iframe [src]="iframeUrl | safe"></iframe>
